import React from 'react';
import { formatDayOrDate, getStartTime } from '../../../../../utils/svtDateAndTime';
import { PlayBadge, THEMES } from '../../../../PlayBadge/PlayBadge';

const LiveBadge = ({ live, broadcastStartTime, broadcastEnded, broadcastedNow }) => {
    if (!live || broadcastEnded) {
        return null;
    }

    if (broadcastedNow) {
        return (
            <PlayBadge text="Direkt" accessibilityText="Direktsänt just nu, " theme={THEMES.LIVE} overlay />
        );
    }

    const startTime = getStartTime(broadcastStartTime);
    const startDay = formatDayOrDate(broadcastStartTime);

    return (
        <PlayBadge
            text={`${startDay} ${startTime}`}
            accessibilityText={'Kommande direktsändning ' + startDay + ' ' + startTime + ', '}
            theme={THEMES.UPCOMING}
            overlay
        />
    );
};

export default LiveBadge;
